export const INSURANCE_TYPE = Object.freeze({
	REGULAR: "ProductInsurance",
	FLEX: "FlexInsurance",
});

export const INSURANCE_MODE = Object.freeze({
	CHANGE: "change",
	REMOVE: "remove",
});
